<ng-container
  *ngIf="currentProductGroupCode$ | async as currentProductGroupCode"
>
  <div class="container" prlwResponsive>
    <div class="filter-container" prlwResponsive>
      <div class="products-wrapper">
        <prlw-group-product-filter></prlw-group-product-filter>
      </div>
      <div class="grow"></div>
      <div class="stations-wrapper" prlwResponsive>
        <prlw-destinations></prlw-destinations>
      </div>
      <prlw-license-countdown-pane
        *ngIf="(xsmall$ | async) === false"
      ></prlw-license-countdown-pane>
    </div>
    <div class="space" *ngIf="(xsmall$ | async) === false"></div>
    <prlw-product-filter
      *ngIf="(currentProductGroupCode !== 'all') && (xsmall$ | async) === false"
    ></prlw-product-filter>

    <ng-container *ngIf="currentProductGroupCode !== 'all'">
      <div
        *ngIf="xsmall$ | async"
        class="spacer"
        [class.gradient]="isBasisBestPriceMobileOutOfIntersection$ | async"
      ></div>

      <prlw-basis-best-price-mobile
        *ngIf="xsmall$ | async"
        [class.basis-best-price-mobile]="reqInstrumentsResult$ | async"
        #basisBestPriceMobile
      ></prlw-basis-best-price-mobile>

      <prlw-basis-counter-label
        *ngIf="xsmall$ | async"
      ></prlw-basis-counter-label>

      <prlw-main-table-header
        *ngIf="xsmall$ | async"
        prlwSyncScroll
      ></prlw-main-table-header>
    </ng-container>

    <div class="table-container" prlwResponsive>
      <ng-container *ngIf="currentProductGroupCode === 'all'; else mainTable">
        <prlw-modifiers></prlw-modifiers>
        <prlw-all-table></prlw-all-table>
      </ng-container>
      <ng-template #mainTable>
        <prlw-table></prlw-table>
      </ng-template>
    </div>
  </div>
</ng-container>
